import React from 'react';
import { EventContentRenderer } from '@/features/b2b/events/components/EventContentRenderer';
import { EventMetadata } from '@/features/b2b/events/components/EventMetadata';

export const EventCard = ({ event, isLastRow, onEventDetailClick }) => {
  return (
    <div className="pb-8">
      <div className="border-b border-[#F3F4F8]">
        <div className="lg:grid lg:grid-cols-[15rem_1fr] lg:gap-8">
          <div className="mb-4 lg:mb-0 overflow-hidden pt-4">
            <img
              src={event.eventImageUrl}
              className="w-full lg:w-[15rem] lg:h-[9.75rem] h-[13.25rem] md:h-[22.5rem] object-cover rounded-lg"
              alt={event.imageAltText}
            />
          </div>

          <div className="lg:pt-4">
            <EventMetadata event={event} />

            <p className="text-[#0C0D1A] text-lg font-semibold pb-4">
              {event.eventTitle}
            </p>

            <EventContentRenderer
              content={event.eventContent}
              className="event-lists"
            />

            <button
              className={`default-button-primary-small mt-6 ${isLastRow ? 'mb-12' : 'mb-12'}`}
              onClick={() => onEventDetailClick(event)}
            >
              {event.eventType === 'Podcast' ? 'Listen to Podcast' : 'Event Details'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
